'use client';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import withRef from '../../utils/withRef';
import Typography from '../Typography/Typography';

export const styles = {
  root: {
    marginRight: 40,
    display: 'inline',
  },
  img: {
    verticalAlign: 'middle',
    maxHeight: 56,
  },
  textLogo: {
    display: 'inline',
  },
  pointer: {
    cursor: 'pointer',
  },
};

const useStyles = makeStyles()(styles);

export const NavigationBarLogo = ({
  className,
  text,
  src,
  href,
  alt,
  onClick,
  forwardedRef: ref,
  ...rest
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.root, className)} {...rest} ref={ref}>
      <a href={href} onClick={onClick} className={onClick && classes.pointer}>
        {src && <img src={src} alt={alt} className={classes.img} />}
        {text && (
          <Typography variant="subtitle" inverse mode="neutral" className={classes.textLogo}>
            {text}
          </Typography>
        )}
      </a>
    </div>
  );
};

export default withRef()(NavigationBarLogo);
